<template>
  <div class="home">

    <el-row v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo))" :gutter="10">
        <el-col :xs="24" :sm="8" :md="8">
            <div class="level">
                <div class="icone">
                    <img src="/public/img/alunos.png" />
                </div>
                <div class="info">
                    <div class="titulo-card">Alunos Matrículados</div>
                    <div v-if="!loadingResumo" class="valor-card">{{ resumoInstituicao.qtd_matriculas }}</div>
                    <div v-else>
                        <div class="valor" style="margin-top: 20px;">
                            <img src="/public/img/loading-bar.gif">
                        </div>
                    </div>
                </div>
            </div>
        </el-col>
        <el-col :xs="24" :sm="8" :md="8">
            <div class="level">
                <div class="icone">
                    <img src="/public/img/salas.png" />
                </div>
                <div class="info">
                    <div class="titulo-card">Turmas</div>
                    <div v-if="!loadingResumo" class="valor-card">{{ resumoInstituicao.turmas }}</div>
                    <div v-else>
                        <div class="valor" style="margin-top: 20px;">
                            <img src="/public/img/loading-bar.gif">
                        </div>
                    </div>
                </div>
            </div>
        </el-col>
        <el-col :xs="24" :sm="8" :md="8">
            <div class="level">
                <div class="icone">
                    <img src="/public/img/professores.png" />
                </div>
                <div class="info">
                    <div class="titulo-card">Professores</div>
                    <div v-if="!loadingResumo" class="valor-card">{{ resumoInstituicao.qtd_professores }}</div>
                    <div v-else>
                        <div class="valor" style="margin-top: 20px;">
                            <img src="/public/img/loading-bar.gif">
                        </div>
                    </div>
                </div>
            </div>
        </el-col>
    </el-row>

    <!-- <el-alert
      class="u-mb-5"
      title="Atenção: O SMGE será retirado do ar neste final de semana (Sábado e Domindo) para manutenção."
      type="warning"
      effect="dark">
    </el-alert> -->
    <el-row v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo)) && ($store.state.config.parametros.fase_matricula == 0 || $store.state.config.parametros.fase_matricula == 1)" :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <div class="panel panel-default">
            <div class="panel-heading" style="border-bottom: 1px solid #dcdfe6;">
              <span>{{ $store.state.config.instituicao.nome }}: REQUERIMENTOS DE MATRÍCULAS 2025</span>              
              <a :href="`${$store.state.config.baseUrlApi}/requerimentos/${$store.state.config.instituicao.id}.pdf`" target="_blank">
                <i class="fas fa-download u-ml-5 u-mt-5" style="float: right; color: #50964d; cursor: pointer;"></i> 
              </a>
            </div>
          </div>
        </el-col>        
    </el-row>
    <!-- <div 
      v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo))" class="u-mb-10" style="text-align: right;">
      <a :href="`${$store.state.config.baseUrlApi}/requerimentos/${$store.state.config.instituicao.id}.pdf`" target="_blank">
        {{ $store.state.config.instituicao.nome }}: REQUERIMENTO DE MATRÍCULAS 202x
      </a>
    </div> -->

    <el-row v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo)) && historicoPendente.mostrar" :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <div class="panel panel-default">
            <div class="panel-heading" style="border-bottom: 1px solid #dcdfe6;">              
                <span style="font-size: 18px;" >Sua Unidade possui alunos com pendência no histórico!</span>
              <i @click="togglePendenciaHistorico" class="fas fa-eye u-ml-5 u-mt-5" style="float: right; color: #50964d; cursor: pointer;"></i>
            </div>
          </div>
        </el-col>        
    </el-row>

    <el-row :gutter="10" v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo)) && false">
      <el-col :xs="24" :sm="24" :md="24">

        <c-panel title="GRÁFICO FREQUÊNCIA" titleIcon='fas fa-users' class="box-home-lis">
          <div style="padding: 20px 30px 0px 30px;">
            
            <bar-chart style="height: 300px;" :chart-data="grafico"></bar-chart>
          
          </div>
        </c-panel>

      </el-col>
    </el-row>

    <!-- <el-row :gutter="10" v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo))">
      <el-col :xs="24" :sm="24" :md="24">

        <div class="panel panel-default painel-agenda" style="border-top: 4px solid #edf1f2 !important">
          <div class="panel-heading" style="border-bottom: 1px solid #dcdfe6;">              
              PERCENTUAL DE FREQUÊNCIA LANÇADA POR TURMA
          </div>
          <div class="panel-body">

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Turma</th>
                        <th class="u-text-right">% lançada</th>
                    </tr>
                </thead>
                <tbody v-if="!loadingConfFrequencia">
                    <tr v-for="(val, i) in confFrequencia" :key="i">
                        <td>{{ i }}</td>
                        <td class="u-text-right">{{ val }}%</td>                        
                    </tr>
                </tbody>
            </table>
            <div v-if="loadingConfFrequencia" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

          </div>
        </div>

      </el-col>
    </el-row>  -->

    <el-row :gutter="10" v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo))">
      <el-col :xs="24" :sm="24" :md="24">

        <div class="panel panel-default painel-agenda" style="border-top: 4px solid #edf1f2 !important">
          <div class="panel-heading" style="border-bottom: 1px solid #dcdfe6;">              
              MEUS DADOS DE CONTATO
              <i @click="openFormUpdateContato()" class="fas fa-pencil-alt u-ml-5 u-mt-5" style="float: right; color: #50964d; cursor: pointer;"></i>
          </div>
          <div class="panel-body">
              <div v-if="loadingGestao" style="text-align: center; min-height: 146px;">
                <img style="margin-top: 88px;" src="/public/img/loading-bar.gif" />
              </div>
              <div v-else style="padding: 0px 30px 0px 30px; margin-top: 10px;">
                <template v-if="gestores['usuario']">
                  <el-row :gutter="10">
                      <el-col :xs="24" :sm="12" :md="12">
                          <dl>
                              <dt style="width: 45px;">
                                <img src="/public/img/whatsapp.png" />
                              </dt>
                              <dd>
                                  {{ (gestores['usuario']['telefone'] ? gestores['usuario']['telefone'] : '-') }}
                              </dd>
                          </dl>
                      </el-col>
                      <el-col :xs="24" :sm="12" :md="12">
                          <dl>
                              <dt style="width: 45px;">
                                <img src="/public/img/email.png" />
                              </dt>
                              <dd>
                                  {{ (gestores['usuario']['email']) ? gestores['usuario']['email'] : '-' }}
                              </dd>
                          </dl>
                      </el-col>
                  </el-row>
                </template>
              </div>
              <i style="padding: 0px 30px;">Você pode alterar os seus dados de contato clicando no lápis no canto superior direito.</i>
          </div>
        </div>

      </el-col>
    </el-row>    

    <el-row :gutter="10">

      <el-col :xs="24" :sm="12" :md="12" v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo))">

        <c-panel title="INSTITUIÇÃO" titleIcon='fas fa-users' class="box-home-lis">
          <div style="padding: 20px 30px 0px 30px; min-height: 257px;">

            <div v-if="loadingGestao" style="text-align: center; height: 190px;">
              <img style="margin-top: 88px;" src="/public/img/loading-bar.gif" />
            </div>

            <template v-else>
              <el-row :gutter="10" class="">
                  <el-col :xs="24" :sm="24" :md="24">
                      <dl>
                          <dt>INSTITUIÇÃO</dt>
                          <dd>
                              {{ $store.state.config.instituicao.nome }}
                          </dd>
                      </dl>
                  </el-col>
              </el-row>

              <template v-if="gestores['servidores']">
                <el-row :gutter="10" v-for="item in gestores['servidores']['DIRETOR']" :key="item['id']">
                    <el-col :xs="24" :sm="24" :md="24">
                        <dl>
                            <dt>DIRETOR (A)</dt>
                            <dd>
                                {{ item['nome'] }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10" v-for="item in gestores['servidores']['VICE_DIRETOR']" :key="item['id']">
                    <el-col :xs="24" :sm="24" :md="24">
                        <dl>
                            <dt>VICE-DIRETOR</dt>
                            <dd>
                                {{ item['nome'] }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10" v-for="item in gestores['servidores']['SECRETARIO_ESCOLAR']" :key="item['id']">
                    <el-col :xs="24" :sm="24" :md="24">
                        <dl>
                            <dt>SECRETÁRIO</dt>
                            <dd>
                                {{ item['nome'] }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
                <el-row :gutter="10" v-for="item in gestores['servidores']['COORDENADOR_PEDAGOGICO']" :key="item['id']">
                    <el-col :xs="24" :sm="24" :md="24">
                        <dl>
                            <dt>COORD. PED.</dt>
                            <dd>
                                {{ item['nome'] }}
                            </dd>
                        </dl>
                    </el-col>
                </el-row>
              </template>
            </template>
          
          </div>
        </c-panel>

      </el-col>

      <!-- <el-col :xs="24" :sm="[0, 1, 3, 12].includes(Number($store.state.user.tipo)) ? 12 : 24" :md="[0, 1, 3, 12].includes(Number($store.state.user.tipo)) ? 12: 24">
        <c-panel title="USUÁRIOS" colorIcon='#349FAD' titleIcon='fas fa-users' class="box-home-list painel-usuarios" v-loading="loading">

          <el-input @keyup.native.enter="getUsuarios" size="small" class="search-secretario" placeholder="pesquisar.." v-model="filtroSearchUsuarios" maxlength="191"></el-input>

          <div class="container-list-secretarios">

            <div v-if="loadingUsuarios" class="loading-list-secretarios">
              <img src="/public/img/loading-bar.gif" />
            </div>

            <template v-if="!loadingUsuarios">
              <ul class="list-secretarios">
                <li v-for="(item, i) in usuarios" :key="i" @click="showFormContatoUsuario(item)">
                  <a class="item-list-secretarios" href="javascript:void(0)">
                    <div class="avatar">
                      <img src="/public/img/perfil.jpg" />
                    </div>
                    <div class="info">
                      <span>{{ item.instituicao }}</span>
                      <span>{{ item.usuario }} - {{ $CONSTANTS.TIPO_USER[item.tipo] }}</span>
                    </div>
                  </a>
                </li>
              </ul>
            </template>

          </div>

        </c-panel>
      </el-col> -->

    </el-row>

    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24">

        <div class="panel panel-default painel-agenda" style="border-top: 4px solid #E6A23C !important">

          <div class="panel-heading">
              <i class="far fa-calendar-alt" style="color: #E6A23C"></i>
              PUBLICAÇÕES
              <i @click="openFormAgenda()" class="fas fa-plus u-mt-5" style="float: right; color: #E6A23C; cursor: pointer;"></i>
          </div>
          <div class="panel-body">
              <div class="container-list-agenda scrollbar-custom">

                <div v-if="loadingEventos" class="loading-list-mensagens">
                  <img src="/public/img/loading-bar.gif" />
                </div>

                <template v-if="!loadingEventos">
                  <div class="container-table">
                      <table class="table table-striped">
                          <thead>
                              <tr>
                                  <th style="color: #737373; width: 90px;">Data</th>
                                  <th style="color: #737373">Descrição</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(item, i) in eventos" :key="i">
                                  <td @click="openInfoEvento(item)" style="cursor: pointer;">
                                    <span>{{ $moment(item.data).format('DD/MM HH:mm') }}</span>
                                  </td>
                                  <td class="ellipsis" @click="openInfoEvento(item)" style="cursor: pointer;">
                                    <span class="ellipsis-text">
                                      <b class="u-mr-5">{{ item.titulo }}</b>
                                      <i>{{ item.evento }}</i>
                                    </span>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                </template>

              </div>
          </div>
        </div>
      </el-col> 
    </el-row>

    
    <el-dialog :close-on-click-modal="false" title="ALTERAR DADOS DE CONTATO" :visible.sync="dialogUpdateContato">
        <div v-if="dialogUpdateContato" style="margin-top: 20px;">

          <el-form @submit.native.prevent="onSubmitFormUpdateContato" :model="formUpdateContato" ref="formUpdateContato" label-position="top" class="reset-text-transform">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="Telefone" prop="telefone" key="telefone">
                      <el-input v-model="formUpdateContato.telefone" v-mask="'(##) #########'" v-on:blur="validTelefone()" maxlength="191"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="E-mail" prop="email" key="email">
                      <el-input v-model="formUpdateContato.email" maxlength="191"></el-input>
                  </el-form-item>
              </el-col>
            </el-row> 
            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item class="u-text-right u-mt-15">
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-form>

        </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="NOVA PUBLICAÇÃO" :visible.sync="dialogFormAgenda" v-on:close="closeDialogFormAgenda">
        <div v-if="dialogFormAgenda" style="margin-top: 20px;">

          <el-form @submit.native.prevent="onSubmitFormAgenda" :model="formAgenda" ref="formAgenda" label-position="top" class="reset-text-transform">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12">
                  <el-form-item label="Data da Publicação" prop="data" :rules="[$requiredBlur]" key="data">
                    <el-date-picker v-model="formAgenda.data" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
                  </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12">
                  <el-form-item label="Hora da Publicação" prop="hora" :rules="[$requiredBlur]" key="hora">
                    <el-input v-mask="'##:##'" v-model="formAgenda.hora" maxlength="191"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="Título" prop="titulo" :rules="[$requiredBlur]" key="titulo">
                      <el-input v-model="formAgenda.titulo" maxlength="191"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Texto" prop="evento" :rules="[$requiredBlur]" key="evento">
                        <el-input :rows="5" type="textarea" v-model="formAgenda.evento"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Anexo (opcional)" key="anexo">
                        <el-upload
                            class="upload-demo"
                            :auto-upload="false"
                            action="#"
                            :http-request="dummyUpload"
                            :limit="1"
                            :file-list="agendaFileList"
                            :on-change="onAgendaFileChange"
                            :on-remove="onAgendaFileRemove"
                        >
                            <el-button slot="trigger" size="small" type="primary">Selecionar arquivo</el-button>
                            <div class="el-upload__tip" slot="tip">Anexe 1 arquivo (pdf, jpg, png, doc, docx...)</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item class="u-text-right u-mt-15">
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-form>

        </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="VISUALIZAR PUBLICAÇÃO" :visible.sync="dialogInfoEvento">
        <div v-if="dialogInfoEvento">

          <div class="u-text-right u-mt-20">
            <a href="javascript:void(0)" @click="deleteEvento(eventoSelected.id)" v-if="eventoSelected.user_id == $store.state.user.id" title="Remover Evento da Agenda">
              <i class="far fa-trash-alt"></i>
              Remover
            </a>
          </div>

          <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24">
                  <fieldset>
                      <legend>DATA</legend>
                      {{ $moment(eventoSelected.data).format('DD/MM/YYYY HH:mm') }}
                  </fieldset>
              </el-col>
          </el-row>
          <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24">
                  <fieldset>
                      <legend>TÍTULO</legend>
                      {{ eventoSelected.titulo }}
                  </fieldset>
              </el-col>
          </el-row>
          <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24">
                  <fieldset>
                      <legend>PUBLICAÇÃO</legend>
                      {{ eventoSelected.evento }}
                  </fieldset>
              </el-col>
          </el-row>
          <el-row :gutter="10" v-if="eventoSelected.anexo_path">
              <el-col :xs="24" :sm="24" :md="24">
                  <fieldset>
                      <legend>ANEXO</legend>
                      <a :href="`${$store.state.config.baseUrlApi}/storage/${eventoSelected.anexo_path}`" target="_blank">
                          {{ eventoSelected.anexo_nome ? eventoSelected.anexo_nome : 'Baixar anexo' }}
                      </a>
                  </fieldset>
              </el-col>
          </el-row>
          <el-row :gutter="10">
              <el-col :xs="24" class="u-text-right">
                <el-button size="small" type="danger" @click="dialogInfoEvento = false">FECHAR</el-button>
              </el-col>
          </el-row>

        </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="CONTATO USUÁRIO" :visible.sync="dialogContatoUsuario" v-on:close="closeDialogContatoUsuario">
        <div v-if="dialogContatoUsuario" style="margin-top: 20px;">
            <el-row :gutter="10" class="u-mt-20">
                <el-col :xs="24" :sm="24" :md="24">
                    <fieldset>
                      <legend>USUÁRIO</legend>
                      {{ usuarioSelected.usuario }}
                    </fieldset>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="u-mt-20" v-if="usuarioSelected.tipo < 3">
                <el-col :xs="24" :sm="24" :md="24">
                    <fieldset>
                      <legend>INSTITUIÇÃO</legend>
                      {{ usuarioSelected.instituicao }}
                    </fieldset>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="u-mt-20">
                <el-col :xs="24" :sm="24" :md="24">
                    <fieldset>
                      <legend>TIPO DE USUÁRIO</legend>
                      {{ $CONSTANTS.TIPO_USER[usuarioSelected.tipo] }}
                    </fieldset>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="u-mt-20">
                <el-col :xs="24" :sm="12" :md="12">
                  <div style="display: flex; background-color: #4CAF50; padding: 10px;">
                    <img src="/public/img/whatsapp.png" />
                    <div style="display: flex; align-items: center; color: #fff; margin-left: 10px; font-size: 17px;">
                      <a style="color: #ffffff;" v-if="usuarioSelected.telefone" :href="'https://web.whatsapp.com/send?phone=55' + usuarioSelected.telefone.replace(/[()\s]/g, '') + '&text=Olá, ' + usuarioSelected.usuario + '!'" target="_blank">
                          {{ usuarioSelected.telefone }}
                      </a>
                      <span v-if="!usuarioSelected.telefone">-</span>
                    </div>
                  </div>

                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                  <div style="display: flex; background-color: #4c6aaf; padding: 10px;">
                    <img src="/public/img/email.png" />
                    <div style="display: flex; align-items: center; color: #fff; margin-left: 10px; font-size: 17px;">
                      {{ (usuarioSelected.email) ? usuarioSelected.email : '-' }}
                    </div>
                  </div>
                </el-col>
            </el-row>
        </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="PENDÊNCIA" :visible.sync="situacaoAcademicaPendente.mostrar">
        <div v-if="situacaoAcademicaPendente.mostrar" style="margin-top: 20px;">

          <div style="display: flex; justify-content: center; align-items: end;">
            <b style="font-size: 28px; margin-left: 10px;">Atenção!</b>
          </div>
          <p style="font-size: 15px; margin-top: 30px;">
            Sua instituição, a <b>{{ $store.state.config.instituicao.nome }}</b>, 
            possui {{ situacaoAcademicaPendente.turmas.length }} {{ situacaoAcademicaPendente.turmas.length > 1 ? 'turmas' : 'turma' }}
            com aluno (s) que ainda não tiveram a situação acadêmica informada.
          </p>
          <p style="font-size: 15px;" v-if="situacaoAcademicaPendente.turmas.length > 1">
            As turmas que possuem alunos com situação acadêmica pendente são:
          </p>
          <p style="font-size: 13px;" v-else>
            A turma que possui aluno (s) com situação acadêmica pendente é:
          </p>
          <table class="table table-striped">
            <thead>
                <tr>
                    <th class="hidden-mobile" style="width: 70px;">Turma</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in situacaoAcademicaPendente.turmas" :key="item.id">
                    <td>{{ `${item.curso.nome} - ${item.nome}`  }}</td>
                </tr>
            </tbody>
          </table>
          <p style="font-size: 13px;">
            Você deverá acessar o menu [turma > Situação Acadêmica], selecionar a modalidade e turma e informar a situação acadêmica dos alunos pendentes.
          </p>
          <el-row :gutter="10">
              <el-col :xs="24" class="u-text-right u-mt-10">
                <el-button size="small" type="danger" @click="situacaoAcademicaPendente.mostrar = false">FECHAR</el-button>
              </el-col>
          </el-row>
        </div>
    </el-dialog>

  </div>
</template>
<script>
import cPanel from '../../../shared/c-panel/c-panel.vue';
import pendenciaHistorico from '@/components/pendencia-historico/list';
import BarChart from '../../../chart/BarChart'

export default {
  components: { cPanel, pendenciaHistorico, BarChart },
  data () {
    return {
      loadingConfFrequencia: true,
      confFrequencia: [],
      grafico: {
        "labels": [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
        ],
        "datasets": [
        {
                "data": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                ],
                "label": "Presença / Março",
                "backgroundColor": "#346daa"
            },
            {
                "data": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,                    
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                ],
                "label": "Faltas / Março",
                "backgroundColor": "#ff774c"
            },            
        ]
      },
      situacaoAcademicaPendente: {
        turmas: [],
        mostrar: false
      },
      urlApi: process.env.VUE_APP_BASE_URL,
      resumoInstituicao: {
        qtd_matriculas: '',
        turmas: '',
        qtd_professores: ''
      },
      usuarioSelected: {},
      eventoSelected: {},
      filtroSearchUsuarios: '',
      dialogFormAgenda: false,
      dialogInfoEvento: false,
      dialogContatoUsuario: false,
      dialogUpdateContato: false,
      loadingEventos: false,
      loadingUsuarios: false,
      loadingGestao: false,
      loadingResumo: true,
      loading: false,
      eventos: [],
      usuarios: [],
      mensagens: [],
      gestores: [],
      formAgenda: {
        data: '',
        hora: '',
        titulo: '',
        evento: '',
        visibilidade: ''
      },
      agendaFileList: [],
      agendaFileRaw: null,
      formUpdateContato: {
        telefone: '',
        email: ''
      },
      historicoPendente: {        
        mostrar: false
      }

    }
  },
  mounted() {

    // this.getConfFrequencia();

    if([0, 1, 3, 12].includes(Number(this.$store.state.user.tipo))){

      this.getResumoDashBoardEscola();
    }

    this.getEventosAgenda();
    this.getUsuarios();
    this.getGestao();

    // if([0, 1, 3, 12].includes(Number(this.$store.state.user.tipo)) && (
    //     this.$store.state.config.parametros.fase_matricula == 2 || 
    //     this.$store.state.config.parametros.fase_matricula == 3
    // )){
    //   this.verificaSituacaoAcademicaPendente();
    // }

    if([0, 1, 3, 12].includes(Number(this.$store.state.user.tipo))){
      this.getHitoricosPendentes();
    }
  },
  methods: {
    getConfFrequencia() {

      let i = this.$store.state.config.instituicao.id;
      
      if(!i) {
        return;
      }

      this.loadingConfFrequencia = true;
      
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/getFrequenciaForConferencia/${i}`, this.$store.getters.getHeaderAuth).then(response => {

        this.confFrequencia = response.data;
        this.loadingConfFrequencia = false;

      }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
      
    },
    verificaSituacaoAcademicaPendente(){

      let i = this.$store.state.config.instituicao.id;
      let p = this.$store.state.config.periodo.id;

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getSituacaoAcademicaPendente/${i}/${p}`, this.$store.getters.getHeaderAuth).then(response => {

        if(response.data && response.data.length > 0){
          this.situacaoAcademicaPendente.turmas = response.data;
          this.situacaoAcademicaPendente.mostrar = true;
        }

      }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

    },
    getGestao(){

      let i = this.$store.state.config.instituicao.id;

      if(!i){
        return false;
      }

      this.loadingGestao = true;

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/servidor/getGestao/${i}`, this.$store.getters.getHeaderAuth).then(response => {

        this.formUpdateContato.telefone = response.data['usuario']['telefone'];
        this.formUpdateContato.email = response.data['usuario']['email'];      

        this.gestores = response.data;

        this.loadingGestao = false;

      }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

    },
    getResumoDashBoardEscola(){

      let i = this.$store.state.config.instituicao.id;
      let p = this.$store.state.config.periodo.id;

      this.loadingResumo = true;

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/sistema/getResumoDashBoardEscola/${i}/${p}`, this.$store.getters.getHeaderAuth).then(response => {

        this.resumoInstituicao = response.data;
        this.loadingResumo = false;

      }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

    },
    showFormContatoUsuario(item){

      this.usuarioSelected = item;
      this.dialogContatoUsuario = true;
    },
    closeDialogContatoUsuario(){

      this.usuarioSelected = {};
    },
    getUsuarios(){

      this.loadingUsuarios = true;

      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/usuario/getUsuariosForDashboard`, {filtro: this.filtroSearchUsuarios}, this.$store.getters.getHeaderAuth).then(response => {

        this.usuarios = response.data;
        this.loadingUsuarios = false;

      }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

    },
    openFormAgenda(){

      this.dialogFormAgenda = true;
    },
    openFormUpdateContato(){
      this.dialogUpdateContato = true;
    },
    onSubmitFormUpdateContato(){

      console.log(this.formUpdateContato);

      window.eventBus.$emit('loading', true);

      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/usuario/updateDadosContado`, this.formUpdateContato, this.$store.getters.getHeaderAuth).then(response => {

        window.eventBus.$emit('loading', false);
        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

        this.dialogUpdateContato = false;
        this.getGestao();

      }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

    },
    onSubmitFormAgenda(){

      this.$refs.formAgenda.validate((valid) =>{ if(valid){

          window.eventBus.$emit('loading', true);

          const fd = new FormData();
          fd.append('data', this.formAgenda.data);
          fd.append('hora', this.formAgenda.hora);
          fd.append('titulo', this.formAgenda.titulo);
          fd.append('evento', this.formAgenda.evento);
          if(this.formAgenda.visibilidade) fd.append('visibilidade', this.formAgenda.visibilidade);
          if(this.agendaFileRaw) fd.append('anexo', this.agendaFileRaw);

          const opt = JSON.parse(JSON.stringify(this.$store.getters.getHeaderFileAuth));
          opt.headers['Content-Type'] = 'multipart/form-data';

          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/agenda/store`, fd, opt).then(response => {

            window.eventBus.$emit('loading', false);
            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

            this.dialogFormAgenda = false;
            this.getEventosAgenda();


          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

      }else{
          window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
      }});

    },
    getEventosAgenda(){

      this.loadingEventos = true;

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/agenda/getEventosEmAberto`, this.$store.getters.getHeaderAuth).then(response => {

        this.eventos = response.data;
        this.loadingEventos = false;

      }).catch((error) => { this.$store.commit('throwException', error); });

    },
    deleteEvento(id){

      this.$msgbox.confirm('Tem certeza que deseja excluir esta publicação?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

          window.eventBus.$emit('loading', true);

          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/agenda/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {

              window.eventBus.$emit('loading', false);
              window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
              this.getEventosAgenda();
              this.dialogInfoEvento = false;

          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

      }).catch(()=>{});

    },
    openInfoEvento(item){

      this.eventoSelected = item;
      this.dialogInfoEvento = true;

    },
    closeDialogFormAgenda(){

      this.formAgenda = { data: '', hora: '', titulo: '', evento: '' };
      this.agendaFileList = [];
      this.agendaFileRaw = null;
      this.viewEvento = false;
    },
    dummyUpload(){
      // evita upload automático; enviamos junto no submit via FormData
      return;
    },
    onAgendaFileChange(file, fileList){
      this.agendaFileList = fileList.slice(-1);
      this.agendaFileRaw = file && file.raw ? file.raw : null;
    },
    onAgendaFileRemove(){
      this.agendaFileList = [];
      this.agendaFileRaw = null;
    },
    validTelefone(){
    
        if(!this.formUpdateContato.telefone)
          return false;

        if(this.formUpdateContato.telefone.length < 13)
          this.formUpdateContato.telefone = '';

    },
    getHitoricosPendentes(){    

          let i = this.$store.state.config.instituicao.id;

          this.historicoPendente.mostrar = false;

          this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getHistoricoPendente/${i}`, this.$store.getters.getHeaderAuth).then(response => {
                        
                if(response.data.total > 0){                 
                  
                  this.historicoPendente.mostrar = true;
                }
                

          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

    },
    togglePendenciaHistorico(){
      this.$router.push({ name: 'pendenciaHistorico' });      
    }

  }
}
</script>
